import { creaMasonry } from "../masonry";
import listaDesplegable from "./lista_desplegable";
import convierteFormularios from "./catalogo";
import carrusel from "./carrusel";
import galeria from "./galeria";
import banner from "./banner";
var bloques = function () {
    if (document.querySelector('.masonry-elementos')) {
        var masonry = creaMasonry('.masonry-elementos');
        masonry.inicializa();
    }
    listaDesplegable();
    galeria();
    convierteFormularios('.catalogo-comprar');
    var slider = document.querySelector('.carrusel-lista');
    if (slider instanceof HTMLElement) {
        carrusel(slider);
    }
    banner();
};
export default bloques;
